import { render } from "./CustomerDialogData.vue?vue&type=template&id=0c98c3a9"
import script from "./CustomerDialogData.vue?vue&type=script&lang=js"
export * from "./CustomerDialogData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__